import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
} from "../../shared/enums/closedcandidates_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleClosedcandidate } from "../../shared/hooks/UseClosedcandidate";
const ViewClosedcandidate = ({ match }) => {
  const [data] = useSingleClosedcandidate(match.params.id);
  const { closedcandidate_loading, closedcandidate } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!closedcandidate_loading ? (
          closedcandidate && (
            <SingleView
              data={closedcandidate}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={closedcandidate._id}
              SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewClosedcandidate;
